import React from 'react';

export const SectionTitle = ({ children, subtitle }) => {
  return (
    <div className="text-center mb-16 animate-on-scroll opacity-0" style={{ transform: 'translateY(30px)' }}>
      <h2
        className="text-4xl md:text-5xl font-bold tracking-wider mb-4 led-text relative inline-block animate-led-pulse"
        style={{ textShadow: '0 0 15px #00a8ff, 0 0 30px #4cd3ff' }}
      >
        {children}
        <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-[#00a8ff]" style={{ boxShadow: '0 0 15px #00a8ff' }}></span>
      </h2>
      {subtitle && (
        <p className="text-xl text-white mt-8" style={{ textShadow: '0 0 8px #00a8ff' }}>
          {subtitle}
        </p>
      )}
    </div>
  );
};